import xhttp from 'src/utils/xhttp'

/**
 * login
 *
 * @param account
 * @param password
 * @returns Promise
 */
export function login(account, password, captcha) {
    const payload = { account, password }
    if (captcha) {
        payload.captcha = captcha
    }
    return xhttp.post('/api/auth/dev/login', payload)
}

/**
 * logout
 *
 * @returns Promise
 */
export function logout() {
    return xhttp.get('/api/auth/dev/logout')
}

/**
 * detail
 *
 * @returns Promise
 */
export function detail() {
    return xhttp.get('/api/dev/account/detail')
}

/**
 * update pwd
 *
 * @returns Promise
 */
export function updatePwd(oldPwd, newPwd) {
    return xhttp.post('/api/dev/account/update-pwd', {
        old_pwd: oldPwd,
        new_pwd: newPwd
    })
}

/**
 *  update email
 *
 * @returns Promise
 */
export function updateEmail(email) {
    return xhttp.post('/api/dev/account/update-email', { email })
}

/**
 *  [USER MANAGE] get domain user list
 * 获取子账号列表
 *
 * @param {Number} page
 * @param {Number} pageSize
 * @param {String} keyword
 * @returns Promise
 */
export function getDomainUsers({ page = 1, pageSize = 10, name = '' }) {
    return xhttp.get('/api/dev/account-sub/list', {
        params: { page, pageSize, name }
    })
}

/**
 *  [USER MANAGE] add domain user
 *  增加子账号
 * @param {String} params.account
 * @param {String} params.role
 * @returns Promise
 */
export function addDomainUser(params) {
    return xhttp.post('/api/dev/account-sub/editor', params)
}

/**
 *  [USER MANAGE] delete domain user
 *
 * @returns Promise
 */
export function deleteDomainUser(account) {
    return xhttp.delete(`/api/dev/account-sub/delete/${account}`)
}

/**
 *  [USER MANAGE] query PRIMARY account list
 *
 * @returns Promise
 */
export function getPrimaryAccountList() {
    return xhttp.get('/api/dev/account-sub/master')
}

/**
 *  [USER MANAGE] 切换账户
 *
 * @returns Promise
 */
export function switchPrimaryAccount(accountId) {
    return xhttp.get(`/api/dev/account-sub/switch-group/${accountId}`)
}

/**
 * 获取域账号列表-模糊查询
 *
 * @param {Number} page
 * @param {Number} pageSize
 * @param {String} keyword
 * @returns Promise
 */
export function queryAccount({ name = '' }) {
    return xhttp.get(`/api/dev/account-sub/get-user/${name}`)
}

/**
 *  [USER AUTHORITIES] 查询用户动作点权限
 *
 * @returns Promise
 */
export function getActionMap() {
    return xhttp.get('/api/dev/webapp/authority-point')
}

/**
 *  [USER need Captcha] 查询用户是否需要验证码
 *
 * @returns Promise
 */
export function checkCaptcha(params) {
    return xhttp.get('/api/auth/dev/need-captcha', { params })
}

/**
 *  [USER Captcha] 获取登录验证码
 *
 * @returns Promise
 */
export function getCaptcha(params) {
    return xhttp.get('/api/auth/dev/captcha', { params })
}
